import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { map, catchError, switchMap, filter, take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DataPersistenceService } from '../data-persistence/data-persistence.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private dataPersistenceService: DataPersistenceService
  ) {}

  refreshToken(): Observable<any> {
    if (this.refreshTokenInProgress) {
      return this.refreshTokenSubject.pipe(
        filter(result => result !== null),
        take(1)
      );
    }

    this.refreshTokenInProgress = true;
    this.refreshTokenSubject.next(null);

    const headers = new HttpHeaders().set('X-Skip-Snackbar', 'true');
    return this.http
      .get<{ accessToken: string }>(
        `${
          environment.urlApiSSO
        }/api/v1/autenticacion/refrescartoken?token=${this.dataPersistenceService.getRefreshToken()}`,
        { headers }
      )
      .pipe(
        map((data) => {
          if (data && data.accessToken !== '') {
            this.dataPersistenceService.saveAccessToken(data.accessToken);
            this.refreshTokenInProgress = false;
            this.refreshTokenSubject.next(data);
            return data;
          } else {
            this.logout();
            throw new Error('No access token in response');
          }
        }),
        catchError((error) => {
          this.refreshTokenInProgress = false;
          this.refreshTokenSubject.next(null);
          return throwError(() => error);
        })
      );
  }

  logout() {
    this.refreshTokenInProgress = false;
    this.refreshTokenSubject.next(null);
    return this.dataPersistenceService.deleteAccessToken();
  }
}